import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function TableSection() {
  return (
    <Card className='mb-8'>
      <CardHeader>
        <CardTitle>Table</CardTitle>
        <CardDescription>Data display in table format</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell className='font-medium'>John Doe</TableCell>
              <TableCell>
                <Badge>Active</Badge>
              </TableCell>
              <TableCell>john@example.com</TableCell>
              <TableCell>
                <Button size='sm' variant='outline'>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className='font-medium'>Jane Smith</TableCell>
              <TableCell>
                <Badge variant='secondary'>Inactive</Badge>
              </TableCell>
              <TableCell>jane@example.com</TableCell>
              <TableCell>
                <Button size='sm' variant='outline'>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className='font-medium'>Bob Johnson</TableCell>
              <TableCell>
                <Badge>Active</Badge>
              </TableCell>
              <TableCell>bob@example.com</TableCell>
              <TableCell>
                <Button size='sm' variant='outline'>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
